/* Animate only the existing server-calculated bar after native cart refresh. */
(() => {
  const drawer = document.getElementById('CartDrawer');
  const panel = drawer?.querySelector('.drawer__panel');
  if (!panel) return;
  let last = panel.querySelector('[data-shipping-progress]');
  let previous = Number(last?.dataset.shippingProgress || 0);
  new MutationObserver(() => {
    const current = panel.querySelector('[data-shipping-progress]');
    if (!current || current === last) return;
    const value = Number(current.dataset.shippingProgress || 0);
    const fill = current.querySelector('.pw-cart-shipping__fill');
    if (fill && value !== previous && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      fill.animate([{width: previous + '%'}, {width: value + '%'}], {duration: 550, easing: 'cubic-bezier(.22,1,.36,1)'});
    }
    last = current;
    previous = value;
  }).observe(panel, {childList: true, subtree: true});
})();
